import { Skeleton } from '@/components/ui/skeleton'

const ApplicationTrendsSkeleton = () => {
  return (
    <div className='bg-white rounded-[1.15rem] p-5 min-h- flex flex-col justify-between'>
      {/* Header Section */}
      <div className='flex justify-between items-center'>
        <Skeleton className='h-6 w-64' />
        <div className='flex items-center gap-2'>
          <Skeleton className='h-10 w-10 rounded-full' />
        </div>
      </div>

      {/* Time Period Selector */}
      <div className='w-full flex justify-end items-start mb-4 mt-4'>
        <Skeleton className='h-8 w-[120px]' />
      </div>

      {/* Chart Area */}
      <div className='mt-4 h-30 sm:h-56 md:h-36 w-full'>
        {/* Chart Grid Lines */}
        <div className='relative h-full w-full'>
          {/* Horizontal grid lines */}
          <div className='absolute inset-0 flex flex-col justify-between'>
            <div className='w-full h-px bg-gray-100'></div>
            <div className='w-full h-px bg-gray-100'></div>
            <div className='w-full h-px bg-gray-100'></div>
            <div className='w-full h-px bg-gray-100'></div>
            <div className='w-full h-px bg-gray-100'></div>
            <div className='w-full h-px bg-gray-100'></div>
          </div>

          {/* Chart Line Skeleton */}
          <div className='absolute inset-0 flex items-end justify-between px-2'>
            <Skeleton className='h-16 w-2' />
            <Skeleton className='h-24 w-2' />
            <Skeleton className='h-20 w-2' />
            <Skeleton className='h-12 w-2' />
            <Skeleton className='h-32 w-2' />
            <Skeleton className='h-18 w-2' />
            <Skeleton className='h-8 w-2' />
          </div>
        </div>
      </div>

      {/* X-axis Labels */}
      <div className='flex justify-between mt-2 px-2'>
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
        <Skeleton className='h-3 w-8' />
      </div>
    </div>
  )
}

export default ApplicationTrendsSkeleton
